export {
  default,
  mapSuggestedFiltersToChipItems
} from './SuggestedFilterChips';
export type { SuggestedFilterChipItem } from './SuggestedFilterChips';
